import { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function TelehealthConsentForm({
  clinic,
  patient,
  sigPad,
  signature,
  viewOnly,
  date,
}) {
  useEffect(() => {
    if (viewOnly) {
      sigPad.current.fromData(signature);
    }
  }, [viewOnly]);

  return (
    <div className="rounded-lg overflow-hidden">
      <div className="p-6 max-w-4xl mx-auto ">
        <h1 className="text-3xl font-bold text-center mb-2">
          Telehealth Consent Form
        </h1>
        <p className="text-center text-gray-600 mb-6">{clinic.name}</p>

        <div className="space-y-4 mb-6">
          <p className="text-gray-800">
            1. I hereby authorize {clinic.name} to use the telehealth practice
            platform for telecommunication for evaluating, testing and
            diagnosing my medical condition.
          </p>
          <p className="text-gray-800">
            2. I understand that technical difficulties may occur before or
            during the telehealth sessions and my appointment cannot be started
            or ended as intended.
          </p>
          <p className="text-gray-800">
            3. I accept that the professionals can contact interactive sessions
            with video call; however, I am informed that the sessions can be
            conducted via regular voice communication if the technical
            requirements such as internet speed cannot be met.
          </p>
          <p className="text-gray-800">
            4. I understand that my current insurance may not cover the
            additional fees of the telehealth practices and I may be responsible
            for any fee that my insurance company does not cover.
          </p>
          <p className="text-gray-800">
            5. I agree that my medical records on telehealth can be kept for
            further evaluation, analysis and documentation, and in all of these,
            my information will be kept private.
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Patient Name:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${patient.lastname} ${patient.firstname}`}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Date:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {viewOnly
              ? new Date(date).toLocaleDateString()
              : new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Signature:</p>
          <div className="border rounded-md p-2">
            <SignatureCanvas
              ref={sigPad}
              canvasProps={{
                className: `signature-canvas w-full h-40 bg-white ${
                  viewOnly ? "pointer-events-none" : ""
                }`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
